module.exports = __webpack_public_path__ + "img/bzfw.9149505e.png";